import { useEffect, useMemo } from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'ui/table';
import { PaginationFooter } from 'ui/paginationFooter';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { InputText } from 'ui/inputs/inputText';
import { PageHeader } from 'ui/pageHeader';
import { fetchWhatsAppMessagesRequest } from '../actions';
import { selectWhatsAppMessages } from '../selectors';
import { configureTableColumns, whatsAppMessagesFilterFn } from '../utils';

export const WhatsAppMessages = () => {
  const dispatch = useDispatch();
  const whatsAppMessages = useSelector(selectWhatsAppMessages);

  const COLUMNS = useMemo(() => configureTableColumns(), []);

  const {
    currentPage,
    filter,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setFilter,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: whatsAppMessages,
    sortedBy: 'createdAt',
    filterFn: whatsAppMessagesFilterFn,
  });

  useEffect(() => {
    dispatch(fetchWhatsAppMessagesRequest());
  }, [dispatch]);

  return (
    <>
      <PageHeader
        pageActions={
          <InputText
            data-test="filter-enabled-accounts"
            value={filter}
            onChange={setFilter}
            placeholder={'Filter by...'}
          />
        }
      >
        WhatsApp Message log
      </PageHeader>
      <Table>
        <TableHeader
          columns={COLUMNS}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          sortedBy={sortedBy}
          setSortedBy={setSortedBy}
        />
        <TableRows columns={COLUMNS} rows={rows} />
      </Table>
      <PaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ page, pageSize }) => {
          setCurrentPage(page);
          setItemsPerPage(pageSize);
        }}
      />
    </>
  );
};

export default withRouter(WhatsAppMessages);
